export default "__VITE_ASSET__Bmw_ek8B__"